import { render, staticRenderFns } from "./ResearchRangeSlider.vue?vue&type=template&id=f8a441cc&scoped=true&"
import script from "./ResearchRangeSlider.vue?vue&type=script&lang=js&"
export * from "./ResearchRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./ResearchRangeSlider.vue?vue&type=style&index=0&id=f8a441cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a441cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a441cc')) {
      api.createRecord('f8a441cc', component.options)
    } else {
      api.reload('f8a441cc', component.options)
    }
    module.hot.accept("./ResearchRangeSlider.vue?vue&type=template&id=f8a441cc&scoped=true&", function () {
      api.rerender('f8a441cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchRangeSlider.vue"
export default component.exports